import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./table.utils";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "@mhe/ngx-shared/pager";
function DataTableFooterComponent_div_1_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", option_r3);
    i0.ɵɵattribute("selected", option_r3 === ctx_r2.localPagingSize ? "selected" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r3, " ");
} }
function DataTableFooterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "label", 6);
    i0.ɵɵtext(2, " Rows per page: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 7);
    i0.ɵɵlistener("ngModelChange", function DataTableFooterComponent_div_1_Template_select_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.localPagingSize = $event); })("change", function DataTableFooterComponent_div_1_Template_select_change_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.firePageSizeChange()); });
    i0.ɵɵtemplate(4, DataTableFooterComponent_div_1_option_4_Template, 2, 3, "option", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "local-paging-size-", ctx_r0.tableId, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "local-paging-size-", ctx_r0.tableId, "");
    i0.ɵɵproperty("ngModel", ctx_r0.localPagingSize);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.localPagingOptions);
} }
function DataTableFooterComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DataTableFooterComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, DataTableFooterComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.rightSideFooterTemplate);
} }
export class DataTableFooterComponent {
    constructor(tableUtils) {
        this.tableUtils = tableUtils;
        this.start = 0;
        this.end = 0;
        this.total = 0;
        this.size = 0;
        this.filtered = false;
        this.currentPageInfo = '';
        this.filterChange = new EventEmitter();
        this.paginationChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        var _a, _b;
        this.total = this.page.totalElements || 0;
        this.size = (_b = (_a = this.page.size) !== null && _a !== void 0 ? _a : this.page.numberOfElements) !== null && _b !== void 0 ? _b : 0;
        const pageNumber = this.page.number || 0;
        const size = this.size || 0;
        const newStart = pageNumber * size + 1;
        if (newStart > this.total) {
            this.start = 0;
        }
        else {
            this.start = newStart;
        }
        const newEnd = pageNumber * this.size + (this.page.numberOfElements || 0);
        if (newEnd > this.total) {
            this.end = this.total;
        }
        else {
            this.end = newEnd;
        }
        const wasFiltered = this.filtered;
        this.filtered = (this.filter && this.filter.length > 0) || this.tableUtils.hasFilter(this.currentColumns);
        this.currentPageInfo = `${this.start} - ${this.end} of ${this.total}${this.filtered ? '(filtered)' : ''}`;
        const currentPageInfoAria = `${this.start} to ${this.end} of ${this.total}${this.filtered ? '(filtered)' : ''}`;
        if (changes.hasOwnProperty('page') && !changes.page.isFirstChange()) {
            const pageChange = changes.page;
            if (pageChange.previousValue.number !== pageChange.currentValue.number) {
                const n = Number(pageChange.currentValue.number) + 1;
                const message = `Page changed to ${n} showing ${currentPageInfoAria}`;
                this.notifierService.postMessage(message);
            }
            else if (this.filtered || wasFiltered) {
                this.notifierService.postMessage('Filtering changed, showing ' + currentPageInfoAria);
            }
        }
        if (changes.hasOwnProperty('filter')) {
            const filterChange = changes.filter;
            if (filterChange.previousValue !== filterChange.currentValue) {
                this.notifierService.postMessage('Filtering changed, showing ' + currentPageInfoAria);
            }
        }
    }
    firePageSizeChange() {
        this.filterChange.emit({
            columns: this.allColumns,
            filter: this.filter,
            localPagingSize: this.localPagingSize,
        });
        const pg = (this.page.number || 0) + 1;
        const message = `Page size changed to ${this.localPagingSize}, page changed to ${pg}`;
        this.notifierService.postMessage(message);
    }
    pagerClicked(event) {
        this.paginationChange.emit(event.pageIndex);
    }
}
DataTableFooterComponent.ɵfac = function DataTableFooterComponent_Factory(t) { return new (t || DataTableFooterComponent)(i0.ɵɵdirectiveInject(i1.DataTableUtils)); };
DataTableFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableFooterComponent, selectors: [["DataTable-table-footer"]], inputs: { leftSideFooterTemplate: "leftSideFooterTemplate", rightSideFooterTemplate: "rightSideFooterTemplate", notifierService: "notifierService", localPaging: "localPaging", localPagingSize: "localPagingSize", localPagingOptions: "localPagingOptions", showLocalPagingOptions: "showLocalPagingOptions", page: "page", currentColumns: "currentColumns", allColumns: "allColumns", filter: "filter", tableId: "tableId" }, outputs: { filterChange: "filterChange", paginationChange: "paginationChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 5, consts: [[1, "info-footer"], ["class", "page-size-controls", 4, "ngIf"], [1, "flex-spacer"], ["class", "right-side-template", 4, "ngIf"], ["role", "navigation", 3, "pageIndex", "pageSize", "length", "page"], [1, "page-size-controls"], [1, "local-paging-options", 3, "for"], ["name", "localPagingSize", 1, "local-paging-size", 3, "ngModel", "id", "ngModelChange", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "right-side-template"], [4, "ngTemplateOutlet"]], template: function DataTableFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DataTableFooterComponent_div_1_Template, 5, 4, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵtemplate(3, DataTableFooterComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementStart(4, "div")(5, "mhe-pager", 4);
        i0.ɵɵlistener("page", function DataTableFooterComponent_Template_mhe_pager_page_5_listener($event) { return ctx.pagerClicked($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        let tmp_2_0;
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.localPaging && ctx.showLocalPagingOptions && ctx.currentColumns.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.rightSideFooterTemplate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("pageIndex", (tmp_2_0 = ctx.page.number) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0)("pageSize", ctx.size)("length", ctx.total);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.PagerComponent], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableFooterComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-table-footer', template: ` <div class="info-footer">
    <div
      class="page-size-controls"
      *ngIf="localPaging && showLocalPagingOptions && currentColumns.length > 0"
    >
      <label for="local-paging-size-{{ tableId }}" class="local-paging-options"> Rows per page: </label>
      <select
        [(ngModel)]="localPagingSize"
        (change)="firePageSizeChange()"
        name="localPagingSize"
        class="local-paging-size"
        id="local-paging-size-{{ tableId }}"
      >
        <option
          *ngFor="let option of localPagingOptions"
          [value]="option"
          [attr.selected]="option === localPagingSize ? 'selected' : null"
        >
          {{ option }}
        </option>
      </select>
    </div>

    <div class="flex-spacer"></div>
    <div *ngIf="rightSideFooterTemplate" class="right-side-template">
      <ng-container *ngTemplateOutlet="rightSideFooterTemplate"></ng-container>
    </div>
    <div>
      <mhe-pager
        role="navigation"
        [pageIndex]="page.number ?? 0"
        [pageSize]="size"
        [length]="total"
        (page)="pagerClicked($event)"
      ></mhe-pager>
    </div>
  </div>`, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: i1.DataTableUtils }]; }, { leftSideFooterTemplate: [{
            type: Input
        }], rightSideFooterTemplate: [{
            type: Input
        }], notifierService: [{
            type: Input
        }], localPaging: [{
            type: Input
        }], localPagingSize: [{
            type: Input
        }], localPagingOptions: [{
            type: Input
        }], showLocalPagingOptions: [{
            type: Input
        }], page: [{
            type: Input
        }], currentColumns: [{
            type: Input
        }], allColumns: [{
            type: Input
        }], filter: [{
            type: Input
        }], tableId: [{
            type: Input
        }], filterChange: [{
            type: Output
        }], paginationChange: [{
            type: Output
        }] }); })();
